module.exports = __webpack_public_path__ + "static/mpost14.fdd3ca69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost14.jpg
// module id = 995
// module chunks = 35783957827783